import React, { useCallback, useEffect, useState } from "react";
import ErrorBoundary from "./ErrorBoundary";
import AppRoute from "./AppRoute";
import ThemeProvider from "themes/ThemeProvider";
import { SWRConfig } from "swr";
import AppConfigProvider from "components/AppConfig/AppConfigProvider";
import LocaleProvider from "locales/LocaleProvider";
import { Helmet } from "react-helmet";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import AuthProvider from "pages/Auth/components/AuthProvider/AuthProvider";
import PageLoading from "components/base/PageLoading";

Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 32 }} spin />);

interface IProps {}

const App = (props: IProps) => {
  useEffect(() => {
    document.getElementById("loader")?.remove();
  }, []);

  const [localeInitializing, setLocaleInitializing] = useState(true);

  const [authInitializing, setAuthInitializing] = useState(true);

  const loading = localeInitializing || authInitializing;

  const handleAuthLoaded = useCallback(() => {
    setAuthInitializing(false);
  }, []);

  const handleLocaleLoaded = useCallback(() => {
    setLocaleInitializing(false);
  }, []);

  return (
    <>
      <Helmet titleTemplate="%s | Tiki AFF"></Helmet>
      <ErrorBoundary>
        <AppConfigProvider>
          <SWRConfig
            value={{
              errorRetryCount: 3,
              errorRetryInterval: 5000,
            }}
          >
            <ThemeProvider>
              <LocaleProvider onLoaded={handleLocaleLoaded}>
                <AuthProvider onLoaded={handleAuthLoaded}>
                  {loading ? <PageLoading loading /> : <AppRoute />}
                </AuthProvider>
              </LocaleProvider>
            </ThemeProvider>
          </SWRConfig>
        </AppConfigProvider>
      </ErrorBoundary>
    </>
  );
};

export default App;
